import React, { useState, useEffect, useRef, useCallback } from "react";
import { ChevronLeft, ChevronRight, ArrowUpRight, Volume2, VolumeX } from "lucide-react";

/* ─────────────────────────────────────────────────
   SLIDE DATA — swap src/poster for your own videos
───────────────────────────────────────────────── */
// const SLIDES = [
//   {
//     src: "https://videos.pexels.com/video-files/3195394/3195394-uhd_2560_1440_25fps.mp4",
//     poster: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=1400&h=800&fit=crop",
//     tag: "Digital Marketing",
//     title: "We Turn Your Digital Mediums Into Lead Generation Machines.",
//     sub: "#1 Digital Marketing Agency in Hyderabad",
//     accent: "#F86C3D",
//   },
//   {
//     src: "https://videos.pexels.com/video-files/3209828/3209828-uhd_2560_1440_25fps.mp4",
//     poster: "https://images.unsplash.com/photo-1553877522-43269d4ea984?w=1400&h=800&fit=crop",
//     tag: "Performance Campaigns",
//     title: "Data-Driven Strategies That Deliver Real Results.",
//     sub: "Google Ads · Meta Ads · SEO · Branding",
//     accent: "#E8553A",
//   },
//   {
//     src: "https://videos.pexels.com/video-files/5532774/5532774-uhd_2560_1440_25fps.mp4",
//     poster: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=1400&h=800&fit=crop",
//     tag: "Brand Growth",
//     title: "100+ Brands Scaled Across India.",
//     sub: "Social Media · Content Creation · Lead Generation · Web Design",
//     accent: "#FF8A5C",
//   },
// ];


const CLOUD_NAME = "dsvqdtg2t"; // ← replace with yours

const cl = (publicId, opts = "") =>
  `https://res.cloudinary.com/${CLOUD_NAME}/video/upload/${opts}/${publicId}`;

const SLIDES = [
  {
    src: cl("kanactify2video_xlydhw", "q_auto,f_auto"),
    poster: cl("kanactify2video_xlydhw", "so_0,f_jpg,q_auto,w_1400"),
    tag: "Digital Marketing",
    // title: "We Turn Your Digital Mediums Into Lead Generation Machines.",
    sub: "Digital Marketing Agency in Hyderabad",
    accent: "#F86C3D",
  },
  {
    src: cl("kanactify3video_evnzj0", "q_auto,f_auto"),
    poster: cl("kanactify3video_evnzj0", "so_0,f_jpg,q_auto,w_1400"),
    tag: "Performance Campaigns",
    // title: "Data-Driven Strategies That Deliver Real Results.",
    sub: "Google Ads · Meta Ads · SEO · Branding",
    accent: "#E8553A",
  },
  {
    src: cl("Amsita_12.05.2026_1_d24n4d", "q_auto,f_auto"),
    poster: cl("Amsita_12.05.2026_1_d24n4d", "so_0,f_jpg,q_auto,w_1400"),
    tag: "Brand Growth",
    // title: "100+ Brands Scaled Across India.",
    sub: "Social Media · Content Creation · Lead Generation · Web Design",
    accent: "#FF8A5C",
  },
];

const DURATION = 5500; // ms per slide

/* ─────────────────────────────────────────────────
   STYLES
───────────────────────────────────────────────── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,900;1,700;1,900&family=DM+Sans:wght@300;400;500;600;700&display=swap');

:root {
  --vh-or: #F86C3D;
  --vh-dor: #D9572E;
  --vh-sor: #FF8A5C;
  --vh-serif: "Playfair Display", Georgia, serif;
  --vh-sans: "DM Sans", sans-serif;
  --vh-ez: cubic-bezier(.4,0,.2,1);
  --vh-sp: cubic-bezier(.34,1.56,.64,1);
  --vh-slide: cubic-bezier(.77,0,.175,1);
  --vh-border: rgba(240,224,208,1);
  --vh-muted: #705848;
  --vh-ink: #0A0A0A;
  --vh-cream: #FFFCF9;
}

.vh-wrap {
  width: 100%;
  background: var(--vh-cream);
  font-family: var(--vh-sans);
  padding-top: 72px;   /* ← add this — matches your navbar height */
}

/* marquee */
.vh-mbar {
  overflow: hidden;
  border-top: 1px solid var(--vh-border);
  border-bottom: 1px solid var(--vh-border);
  padding: 13px 0;
  mask: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);
  -webkit-mask: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);
  background: #FFF0EA;
}
.vh-mtrack { display: flex; width: max-content; animation: vh-mq 32s linear infinite; }
.vh-mi {
  display: flex; align-items: center; gap: 14px;
  padding: 0 28px; font-size: 11px; font-weight: 700;
  letter-spacing: 2px; text-transform: uppercase;
  color: #705848; white-space: nowrap;
}
.vh-ms { color: var(--vh-or); font-size: 10px; }
@keyframes vh-mq { from { transform: translateX(0); } to { transform: translateX(-50%); } }

/* stage */
.vh-stage {
  position: relative;
  width: calc(100% - 48px);
  max-width: 1440px;
  height: 80vh;
  min-height: 480px;
  margin: 16px auto 0;   /* ← was 0 auto */
  border-radius: 28px;
  overflow: hidden;
  box-shadow:
    0 0 0 1px rgba(248,108,61,.18),
    0 32px 80px rgba(10,5,2,.22),
    0 8px 24px rgba(248,108,61,.1);
}

/* track */
.vh-track {
  display: flex;
  height: 100%;
  transition: transform .9s var(--vh-slide);
  will-change: transform;
}

/* individual slide */
.vh-slide {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
}

.vh-slide video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* gradient overlays */
.vh-ov-bot {
  position: absolute; inset: 0;
  background: linear-gradient(
    to top,
    rgba(8,4,2,.85) 0%,
    rgba(8,4,2,.35) 38%,
    rgba(8,4,2,.08) 65%,
    transparent 100%
  );
  pointer-events: none;
}
.vh-ov-left {
  position: absolute; inset: 0;
  background: linear-gradient(
    to right,
    rgba(8,4,2,.45) 0%,
    transparent 60%
  );
  pointer-events: none;
}

/* caption */
.vh-cap {
  position: absolute;
  bottom: 52px;
  left: 52px;
  right: 52px;
  z-index: 4;
}

.vh-pill {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: rgba(248,108,61,.18);
  border: 1px solid rgba(248,108,61,.5);
  border-radius: 100px;
  padding: 5px 16px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: rgba(255,225,205,.95);
  margin-bottom: 18px;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}
.vh-pill-dot {
  width: 5px; height: 5px;
  border-radius: 50%;
  background: var(--vh-or);
  animation: vh-pulse 2s infinite;
}
@keyframes vh-pulse {
  0%,100% { box-shadow: 0 0 0 0 rgba(248,108,61,.6); }
  50% { box-shadow: 0 0 0 6px transparent; }
}

.vh-title {
  font-family: var(--vh-serif);
  font-size: clamp(28px, 4vw, 60px);
  line-height: 1.06;
  font-weight: 900;
  color: #fff;
  margin-bottom: 12px;
  text-shadow: 0 4px 32px rgba(0,0,0,.5);
  max-width: 700px;
  transition: opacity .5s var(--vh-ez), transform .5s var(--vh-ez);
}
.vh-title em { font-style: italic; color: var(--vh-sor); }

.vh-sub {
  font-size: 14px;
  color: rgba(255,205,175,.72);
  font-weight: 500;
  line-height: 1.7;
  max-width: 460px;
  margin-bottom: 30px;
}

.vh-btns {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.vh-btn-p {
  display: inline-flex; align-items: center; gap: 8px;
  padding: 13px 30px; border-radius: 100px;
  background: linear-gradient(135deg, var(--vh-or), var(--vh-dor));
  color: #fff; font-family: var(--vh-sans);
  font-size: 13px; font-weight: 700;
  border: none; cursor: pointer;
  box-shadow: 0 8px 28px rgba(248,108,61,.45);
  transition: transform .25s var(--vh-sp), box-shadow .25s;
}
.vh-btn-p:hover { transform: translateY(-2px); box-shadow: 0 14px 40px rgba(248,108,61,.55); }

.vh-btn-s {
  display: inline-flex; align-items: center; gap: 8px;
  padding: 13px 30px; border-radius: 100px;
  background: rgba(255,255,255,.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  color: #fff; font-family: var(--vh-sans);
  font-size: 13px; font-weight: 600;
  border: 1px solid rgba(255,255,255,.28);
  cursor: pointer;
  transition: background .2s, border-color .2s, transform .2s;
}
.vh-btn-s:hover { background: rgba(255,255,255,.18); border-color: rgba(255,255,255,.5); transform: translateY(-2px); }

/* progress bar */
.vh-prog-rail {
  position: absolute;
  bottom: 0; left: 0; right: 0;
  height: 3px;
  background: rgba(255,255,255,.12);
  z-index: 5;
}
.vh-prog-fill {
  height: 100%;
  border-radius: 0 3px 3px 0;
  background: linear-gradient(90deg, var(--vh-or), var(--vh-sor));
  transition: width 80ms linear;
}

/* slide counter */
.vh-counter {
  position: absolute;
  top: 24px;
  left: 28px;
  z-index: 5;
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(10,5,2,.4);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255,255,255,.15);
  border-radius: 100px;
  padding: 6px 14px;
  font-size: 11px;
  font-weight: 700;
  color: rgba(255,255,255,.8);
  letter-spacing: 1px;
}
.vh-counter-cur { color: var(--vh-sor); }

/* mute btn */
.vh-mute {
  position: absolute;
  top: 24px;
  right: 28px;
  z-index: 5;
  width: 38px; height: 38px;
  border-radius: 50%;
  background: rgba(10,5,2,.4);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255,255,255,.15);
  display: flex; align-items: center; justify-content: center;
  color: rgba(255,255,255,.75);
  cursor: pointer;
  transition: background .2s, color .2s, transform .2s var(--vh-sp);
}
.vh-mute:hover { background: rgba(248,108,61,.4); color: #fff; transform: scale(1.1); }

/* dot indicators */
.vh-dots {
  position: absolute;
  bottom: 20px;
  right: 28px;
  display: flex;
  align-items: center;
  gap: 6px;
  z-index: 5;
}
.vh-dot {
  height: 3px;
  border-radius: 100px;
  border: none;
  cursor: pointer;
  background: rgba(255,255,255,.35);
  transition: background .4s, width .4s var(--vh-sp);
  padding: 0;
  flex-shrink: 0;
}
.vh-dot.on { background: var(--vh-or); }

/* arrow buttons */
.vh-arr {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 5;
  width: 46px; height: 46px;
  border-radius: 50%;
  background: rgba(255,255,255,.1);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255,255,255,.22);
  display: flex; align-items: center; justify-content: center;
  color: #fff;
  cursor: pointer;
  transition: background .2s, transform .2s var(--vh-sp), border-color .2s;
}
.vh-arr:hover {
  background: rgba(248,108,61,.55);
  border-color: rgba(248,108,61,.6);
  transform: translateY(-50%) scale(1.08);
}
.vh-arr-l { left: 22px; }
.vh-arr-r { right: 22px; }

/* stats strip */
.vh-stats {
  display: flex;
  padding: 36px 48px 0;
  border-top: 1px solid var(--vh-border);
  margin-top: 36px;
  flex-wrap: wrap;
  gap: 0;
}
.vh-stat {
  flex: 1;
  min-width: 120px;
}
.vh-stat + .vh-stat {
  padding-left: 28px;
  border-left: 1px solid var(--vh-border);
  margin-left: 28px;
}
.vh-stat-n {
  font-family: var(--vh-serif);
  font-size: clamp(26px, 3.5vw, 44px);
  line-height: 1;
  font-weight: 900;
  background: linear-gradient(135deg, var(--vh-or), var(--vh-dor));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 5px;
}
.vh-stat-l {
  font-size: 11px;
  color: var(--vh-muted);
  font-weight: 600;
  letter-spacing: .5px;
  text-transform: uppercase;
}

/* ── RESPONSIVE ────────────────────────────────── */
@media (max-width: 768px) {
  .vh-stage {
    width: calc(100% - 28px);
    height: 72vh;
    border-radius: 20px;
  }
  .vh-cap { bottom: 30px; left: 28px; right: 28px; }
  .vh-title { font-size: clamp(22px, 7vw, 38px); }
  .vh-sub { font-size: 13px; }
  .vh-arr { display: none; }
  .vh-stats { padding: 28px 20px 0; flex-wrap: wrap; gap: 16px; }
  .vh-stat + .vh-stat { padding-left: 0; border-left: none; margin-left: 0; min-width: 44%; }
}

@media (max-width: 480px) {
  .vh-stage { height: 62vh; border-radius: 16px; width: calc(100% - 20px); }
  .vh-cap { bottom: 24px; left: 20px; right: 20px; }
  .vh-btn-p, .vh-btn-s { padding: 11px 22px; font-size: 12px; width: 100%; justify-content: center; }
  .vh-btns { flex-direction: column; }
}
`;

const MQ_ITEMS = [
  "Social Media Marketing", "Lead Generation", "Google Ads",
  "Meta Ads", "Brand Identity", "Web Design", "Content Creation", "SEO",
];

const STATS = [
  ["100+", "Brands Served"],
  ["50M+", "Impressions"],
  ["6+", "Years Exp."],
  ["98%", "Retention"],
];

/* ─────────────────────────────────────────────────
   COMPONENT
───────────────────────────────────────────────── */
const VideoHero = ({
  onContact,
  onStories,
  slides = SLIDES,
  stats = STATS,
  marqueeItems = MQ_ITEMS,
  duration = DURATION,
  showStats = true,
  showMarquee = true,
}) => {
  const [cur, setCur] = useState(0);
  const [prog, setProg] = useState(0);
  const [muted, setMuted] = useState(true);
  const videoRefs = useRef([]);
  const rafRef = useRef(null);
  const startRef = useRef(Date.now());
  const curRef = useRef(0);

  const goTo = useCallback((idx) => {
    const next = ((idx % slides.length) + slides.length) % slides.length;
    curRef.current = next;
    setCur(next);
    setProg(0);
    startRef.current = Date.now();
    videoRefs.current.forEach((v, i) => {
      if (!v) return;
      if (i === next) {
        v.currentTime = 0;
        v.play().catch(() => {});
      } else {
        v.pause();
      }
    });
  }, [slides.length]);

  // RAF progress ticker
  useEffect(() => {
    const tick = () => {
      const elapsed = Date.now() - startRef.current;
      const p = Math.min((elapsed / duration) * 100, 100);
      setProg(p);
      if (p >= 100) {
        goTo(curRef.current + 1);
      }
      rafRef.current = requestAnimationFrame(tick);
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [duration, goTo]);

  // Initial play
  useEffect(() => {
    const v = videoRefs.current[0];
    if (v) { v.muted = true; v.play().catch(() => {}); }
  }, []);

  // Sync muted state
  useEffect(() => {
    videoRefs.current.forEach((v) => { if (v) v.muted = muted; });
  }, [muted]);

  const slide = slides[cur];

  return (
    <div className="vh-wrap">
      <style>{CSS}</style>

      {/* Marquee */}
      {showMarquee && (
        <div className="vh-mbar">
          <div className="vh-mtrack">
            {[...marqueeItems, ...marqueeItems].map((t, i) => (
              <span key={i} className="vh-mi">
                {t}<span className="vh-ms">★</span>
              </span>
            ))}
          </div>
        </div>
      )}

      {/* Stage */}
      <div className="vh-stage">
        {/* Video track */}
        <div
          className="vh-track"
          style={{ transform: `translateX(-${cur * 100}%)` }}
        >
          {slides.map((s, i) => (
            <div key={i} className="vh-slide">
              <video
                ref={(el) => { videoRefs.current[i] = el; }}
                src={s.src}
                poster={s.poster}
                muted
                playsInline
                preload={i === 0 ? "auto" : "metadata"}
              />
              <div className="vh-ov-bot" />
              <div className="vh-ov-left" />
            </div>
          ))}
        </div>

        {/* Caption */}
        <div className="vh-cap">
          <div className="vh-pill">
            <span className="vh-pill-dot" />
            {slide.tag}
          </div>
          <h1 className="vh-title">{slide.title}</h1>
          <p className="vh-sub">{slide.sub}</p>
          <div className="vh-btns">
            {onContact && (
              <button className="vh-btn-p" onClick={onContact}>
                Start Growing <ArrowUpRight size={15} />
              </button>
            )}
            {onStories && (
              <button className="vh-btn-s" onClick={onStories}>
                View Case Studies
              </button>
            )}
          </div>
        </div>

        {/* Slide counter */}
        <div className="vh-counter">
          <span className="vh-counter-cur">{String(cur + 1).padStart(2, "0")}</span>
          <span style={{ opacity: 0.35 }}>/</span>
          <span>{String(slides.length).padStart(2, "0")}</span>
        </div>

        {/* Mute toggle */}
        <button
          className="vh-mute"
          onClick={() => setMuted((m) => !m)}
          aria-label={muted ? "Unmute" : "Mute"}
        >
          {muted ? <VolumeX size={16} /> : <Volume2 size={16} />}
        </button>

        {/* Progress rail */}
        <div className="vh-prog-rail">
          <div className="vh-prog-fill" style={{ width: `${prog}%` }} />
        </div>

        {/* Dot indicators */}
        <div className="vh-dots">
          {slides.map((_, i) => (
            <button
              key={i}
              className={`vh-dot${cur === i ? " on" : ""}`}
              style={{ width: cur === i ? "28px" : "8px" }}
              onClick={() => goTo(i)}
              aria-label={`Go to slide ${i + 1}`}
            />
          ))}
        </div>

        {/* Arrow navigation */}
        <button className="vh-arr vh-arr-l" onClick={() => goTo(cur - 1)} aria-label="Previous">
          <ChevronLeft size={20} />
        </button>
        <button className="vh-arr vh-arr-r" onClick={() => goTo(cur + 1)} aria-label="Next">
          <ChevronRight size={20} />
        </button>
      </div>

      {/* Stats strip */}
      {showStats && (
        <div className="vh-stats">
          {stats.map(([n, l]) => (
            <div key={l} className="vh-stat">
              <div className="vh-stat-n">{n}</div>
              <div className="vh-stat-l">{l}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VideoHero;